$(document).ready(function() {

//  $("#ine-price-floating-section").stick_in_parent();
  $('#ine-price-floating-section').fadeOut();

});